var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        [
          _c(
            "b-row",
            { staticClass: "justify-content-end" },
            [
              _c(
                "b-col",
                {
                  staticClass: "d-flex justify-content-center",
                  attrs: { md: "3" },
                },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "primary",
                        block: "",
                        to: {
                          path: "/marketing/campaign/add",
                          query: { access_token: _vm.facebookToken },
                        },
                      },
                    },
                    [_vm._v(" Add New Campaign ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            {
              staticClass: "d-flex justify-content-end mb-2 mt-3",
              staticStyle: { position: "relative", "z-index": "1" },
              attrs: { cols: "12" },
            },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "outline-danger" },
                  on: { click: _vm.clearFilters },
                },
                [_vm._v(" Clear Filters ")]
              ),
            ],
            1
          ),
          _c("b-table", {
            attrs: {
              items: _vm.filteredCampaigns,
              fields: _vm.fields,
              striped: "",
              responsive: "",
              "per-page": _vm.perPage,
              "current-page": _vm.currentPage,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.sortDesc,
            },
            on: {
              "update:sortBy": function ($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function ($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function ($event) {
                _vm.sortDesc = $event
              },
              "update:sort-desc": function ($event) {
                _vm.sortDesc = $event
              },
              filtered: _vm.onFiltered,
            },
            scopedSlots: _vm._u([
              {
                key: "head(name)",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("Campaign Name")]),
                        _c("b-form-input", {
                          attrs: { placeholder: "Filter by Name", size: "sm" },
                          on: { input: _vm.filterTable },
                          model: {
                            value: _vm.filters.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "name", $$v)
                            },
                            expression: "filters.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "head(budget)",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("Actual Cost")]),
                        _c("b-form-input", {
                          attrs: {
                            type: "number",
                            placeholder: "Filter by Cost",
                            size: "sm",
                          },
                          on: { input: _vm.filterTable },
                          model: {
                            value: _vm.filters.budget,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "budget", $$v)
                            },
                            expression: "filters.budget",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "head(plannedBudget)",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("Planned Budget")]),
                        _c("b-form-input", {
                          attrs: {
                            type: "number",
                            placeholder: "Filter by Planned Budget",
                            size: "sm",
                          },
                          on: { input: _vm.filterTable },
                          model: {
                            value: _vm.filters.plannedBudget,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "plannedBudget", $$v)
                            },
                            expression: "filters.plannedBudget",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "head(status)",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("Status")]),
                        _c("b-form-select", {
                          attrs: { options: _vm.statusOptions, size: "sm" },
                          on: { change: _vm.filterTable },
                          model: {
                            value: _vm.filters.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "status", $$v)
                            },
                            expression: "filters.status",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "head(createdOn)",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("Created On")]),
                        _c("DatePicker", {
                          staticClass: "small-datepicker",
                          attrs: {
                            range: "",
                            placeholder: "Select Date Range",
                            size: "sm",
                            clearable: false,
                            "input-attr": { readonly: true },
                          },
                          on: {
                            change: _vm.filterTable,
                            focus: _vm.openCalendar,
                          },
                          model: {
                            value: _vm.filters.createdOn,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "createdOn", $$v)
                            },
                            expression: "filters.createdOn",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "head(startDate)",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("Start Date")]),
                        _c("DatePicker", {
                          staticClass: "small-datepicker",
                          attrs: {
                            range: "",
                            placeholder: "Select Date Range",
                            size: "sm",
                            clearable: false,
                            "input-attr": { readonly: true },
                          },
                          on: {
                            change: _vm.filterTable,
                            focus: _vm.openCalendar,
                          },
                          model: {
                            value: _vm.filters.startDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "startDate", $$v)
                            },
                            expression: "filters.startDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "head(endDate)",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("End Date")]),
                        _c("DatePicker", {
                          staticClass: "small-datepicker",
                          attrs: {
                            range: "",
                            placeholder: "Select Date Range",
                            size: "sm",
                            clearable: false,
                            "input-attr": { readonly: true },
                          },
                          on: {
                            change: _vm.filterTable,
                            focus: _vm.openCalendar,
                          },
                          model: {
                            value: _vm.filters.endDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "endDate", $$v)
                            },
                            expression: "filters.endDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "cell(createdOn)",
                fn: function (data) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.formatDate(data.item.createdOn)) + " "
                    ),
                  ]
                },
              },
              {
                key: "cell(startDate)",
                fn: function (data) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.formatDate(data.item.startDate)) + " "
                    ),
                  ]
                },
              },
              {
                key: "cell(endDate)",
                fn: function (data) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.formatDate(data.item.endDate)) + " "
                    ),
                  ]
                },
              },
              {
                key: "cell(status)",
                fn: function (data) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.getStatusText(data.item.status)) + " "
                    ),
                  ]
                },
              },
              {
                key: "cell(avatar)",
                fn: function (data) {
                  return [
                    _c("b-avatar", { attrs: { src: data.value, square: "" } }),
                  ]
                },
              },
              {
                key: "cell(actions)",
                fn: function (data) {
                  return [
                    _c(
                      "b-dropdown",
                      {
                        staticClass: "m-1",
                        attrs: {
                          variant: "link",
                          "toggle-class": "p-0",
                          "no-caret": "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "button-content",
                              fn: function () {
                                return [
                                  _c("feather-icon", {
                                    staticClass: "align-middle text-body",
                                    attrs: {
                                      icon: "MoreVerticalIcon",
                                      size: "16",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c(
                          "b-dropdown-item",
                          {
                            attrs: {
                              to: {
                                name: "marketing-campaign-view",
                                params: { id: data.item.id },
                              },
                            },
                          },
                          [
                            _c("feather-icon", { attrs: { icon: "EyeIcon" } }),
                            _c("span", { staticClass: "align-middle ml-1" }, [
                              _vm._v("View"),
                            ]),
                          ],
                          1
                        ),
                        data.item.status !== "COMPLETED" &&
                        data.item.status !== "CANCELLED"
                          ? _c(
                              "b-dropdown-item",
                              {
                                attrs: {
                                  to: {
                                    name: "marketing-draft-edit",
                                    params: { id: data.item.id },
                                  },
                                },
                              },
                              [
                                _c("feather-icon", {
                                  attrs: { icon: "EditIcon" },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "align-middle ml-1" },
                                  [_vm._v("Edit")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "b-dropdown-item",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.deleteCampaign(data.item.id)
                              },
                            },
                          },
                          [
                            _c("feather-icon", {
                              attrs: { icon: "TrashIcon" },
                            }),
                            _c("span", { staticClass: "align-middle ml-50" }, [
                              _vm._v("Delete"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("b-pagination", {
            staticClass: "my-0",
            attrs: {
              "total-rows": _vm.totalRowsAll,
              "per-page": _vm.perPage,
              align: "center",
              size: "sm",
            },
            model: {
              value: _vm.currentPage,
              callback: function ($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }